import { useState } from 'react';

/**
 * Smart Refresh Hook
 * Provides consistent refresh functionality with loading states and success feedback
 */
const useSmartRefresh = (fetchData, successMessage = 'Data refreshed successfully') => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  const refreshData = async () => {
    if (isRefreshing) return; // Prevent multiple simultaneous refreshes
    
    setIsRefreshing(true);
    
    try {
      // Execute the data fetching function
      if (fetchData) {
        await fetchData();
      }
      
      // Update last updated timestamp
      setLastUpdated(new Date());
      
      // Show success toast (you can integrate with your toast system here)
      console.log(successMessage);
      
      // Optional: Show actual toast notification
      // toast.success(successMessage);
      
    } catch (error) {
      console.error('Refresh failed:', error);
      // Optional: Show error toast
      // toast.error('Failed to refresh data');
    } finally {
      // Keep loading state for minimum duration for better UX
      setTimeout(() => {
        setIsRefreshing(false);
      }, 800);
    }
  };

  const getLastUpdatedText = () => {
    const now = new Date();
    const diffInMinutes = Math.floor((now - lastUpdated) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes === 1) return '1 min ago';
    if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours === 1) return '1 hour ago';
    if (diffInHours < 24) return `${diffInHours} hours ago`;
    
    return lastUpdated.toLocaleDateString();
  };

  return {
    isRefreshing,
    refreshData,
    lastUpdated,
    getLastUpdatedText
  };
};

export default useSmartRefresh;

